module.exports = __webpack_public_path__ + "media/images/icon-google-b2599390a88854f119f125669d47d96e.png";